
<v-card-title class="headline v-flex primary white--text" >
    <div>
        <span class="mr-1" v-if="icon"><v-icon color="white" size="22">{{ icon }}</v-icon></span>
        <span>{{ title }}</span>
    </div>
    <v-spacer />
    <slot name="toolbar" />
    <a @click="onCancel">
        <v-icon size="22" color="white">mdi-close</v-icon>
    </a>
</v-card-title>
